import { createAction, props } from '@ngrx/store';
import { ParsedAddress } from 'app/components/map/map.models';

export const updateParsedAddress = createAction(
  '[Parsed address] Update',
  props<{ parsedAddress: ParsedAddress }>()
);

export const updateParsedAddressSuccess = createAction(
  '[Parsed address] Update Successful',
  props<{ parsedAddress: ParsedAddress }>()
);

export const updateParsedAddressFailed = createAction(
  '[Parsed address] Update Failure',
  props<{ error: any }>()
);

export const loadParsedAddress = createAction('[Parsed address] Load');

export const loadParsedAddressSuccess = createAction(
  '[Parsed address] Load Successful',
  props<{ parsedAddress: ParsedAddress }>()
);

export const loadParsedAddressFailed = createAction(
  '[Parsed address] Load Failure',
  props<{ error: any }>()
);

export const resetParsedAddress = createAction('[Parsed address] Reset');
